/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M10.151 17.836a1.849 1.849 0 1 0 3.698 0 1.849 1.849 0 0 0-3.698 0ZM7.034 13.734a7.02 7.02 0 0 1 9.927 0 .9.9 0 1 1-1.273 1.273 5.22 5.22 0 0 0-7.381 0 .9.9 0 1 1-1.273-1.273Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.44 11.138a10.692 10.692 0 0 1 15.12 0 .9.9 0 0 1-1.273 1.273 8.892 8.892 0 0 0-12.574 0 .9.9 0 1 1-1.273-1.273Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.207 8.191a14.364 14.364 0 0 1 19.586 0 .9.9 0 0 1-1.227 1.317 12.564 12.564 0 0 0-17.132 0 .9.9 0 0 1-1.227-1.317Z"
})), "0 0 24 24", "WifiLight");